import {useRef, useState} from 'react'
import ImageZoom from 'react-image-zooom'
import classNames from 'classnames'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Navigation } from 'swiper/modules'
import { Swiper as SwiperType } from 'swiper'
import { ArrowIcon } from 'assets'
import { useResponsive } from 'hooks'

import styles from './Product.module.scss'
import Skeleton from "../../components/atom/Skeleton";

const Gallery = ({ data, productData ,loading }: any) => {
  const swiperRef = useRef()


  const { isLaptop } = useResponsive()
  const [activeImageId, setActiveImageId] = useState(0)

  const acitveProductIamge = productData?.images?.[activeImageId]

  const updateIndex = (swiperInstance: SwiperType) => {
    if (swiperInstance === null) return
    const currentSlide = swiperInstance?.activeIndex
    setActiveImageId(currentSlide)
  }

  const renderImages = data?.images?.map(({ media_id, original }: any, index: number) => (

          <div
              key={media_id}
              className={classNames(styles.gallery__cards_item, {
                  [styles.gallery__cards_item_active]: index === activeImageId,
              })}
              onClick={() => {
                  ;(swiperRef.current as any)?.slideTo(index)
                  setActiveImageId(index)
              }}
          >
              <img width={88} height={88} src={original} alt='product' />
          </div>
  ))

  const renderSliderImages = data?.images?.map(({ media_id, original, video ,thumb}: any, index: number) => (
    <SwiperSlide key={media_id}>
      <div className={styles.gallery__main} onClick={() => setActiveImageId(index)}>
          {video ?
              <video
                  style={{
                      width: '100%',
                      height: '497px',
                      objectFit: 'cover',
                  }}
                  controls
              >
                  <source src={thumb} type='video/mp4' />
                  Your browser does not support the video tag.
              </video>
          :
              <img width={88} height={88} src={original} alt='product' />
          }
      </div>
    </SwiperSlide>
  ))

  return (
    <div className={styles.gallery}>
      <div className={styles.gallery__cards}>
        <div className={styles.gallery__cards_arrow}>
          <ArrowIcon
            onClick={() => {
              if (activeImageId > 0) {
                setActiveImageId(activeImageId - 1)
              }
            }}
          />
        </div>
        <div className={styles.gallery__cards_wrapper}>{
            loading ?
             Array.from({length:10}).map((index:any)=>
                 <div
                     key={index}
                     style={{minWidth:88}}
                 >
                     <Skeleton width={'88px'} height={'88px'}  />

                 </div>
             )
                :
            renderImages
        }</div>
        <div className={styles.gallery__cards_arrow}>
          <ArrowIcon
            style={{ transform: 'rotate(180deg)' }}
            onClick={() => {
              if (activeImageId < data?.images?.length - 1) {
                setActiveImageId(activeImageId + 1)
              }
            }}
          />
        </div>
      </div>
      <div className={styles.gallery__main}>
        {data?.special && <div className={styles.gallery__main_label}>Знижка</div>}

          {loading ?
              <div className={styles.gallery__main_img_loader}>
                  <Skeleton width={'100%'} height={'100%'} />
              </div>
              :
              acitveProductIamge && !isLaptop ? (
                  acitveProductIamge.video ?
                      <video
                          style={{
                              width: '100%',
                              maxWidth: '100%',
                              height: '520px',
                              maxHeight: '520px',
                              objectFit: 'cover',
                              touchAction: 'none', // предотвращает зум на iOS
                          }}
                          controls
                      >
                          <source src={acitveProductIamge.thumb} type='video/mp4' />
                          Your browser does not support the video tag.
                      </video>
                      :
                      <ImageZoom src={acitveProductIamge.original} alt='product' fullWidth={true} />
              ) : (
                  <Swiper
                      loop={renderSliderImages?.length > 1}
                      initialSlide={0}
                      onBeforeInit={(swiper: any) => {
                          swiperRef.current = swiper as any
                      }}
                      onRealIndexChange={updateIndex}
                      modules={[Autoplay, Navigation]}
                      spaceBetween={28}
                      slidesPerView={1}
                      loopAdditionalSlides={renderSliderImages?.length > 1 ? 1 : 0}
                  >
                      {renderSliderImages}
                  </Swiper>
              )
          }

      </div>
    </div>
  )
}

export default Gallery
